import type { IconData } from '@stacksjs/iconify-core'

export const interfaceEssentialVoiceId: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M30.48 25.9H32v4.58h-1.52Zm0-24.38H32v4.57h-1.52Zm0 12.19h-1.53v-1.52h-1.52v3.05h-1.52v-4.57h-1.53V9.14h-1.52v4.57h-1.52v1.53h-1.53v-3.05h-1.52v-1.52h-1.53V7.62h-1.52v1.52h-1.52v3.05h-1.53v3.05h-1.52v-6.1H9.15v1.53H7.62v1.52H6.1v3.05H4.57v-1.53H3.05v-1.52H1.53v3.05H0v1.52h1.53v3.05h1.52v-1.53h1.52v-1.52H6.1v1.52h1.52v3.05h1.53v1.53h1.52v-6.1h1.52v3.05h1.53v3.05h1.52v1.52h1.52v-3.05h1.53v-3.05h1.52v-1.52h1.53v1.52h1.52v4.58h1.52v-1.53h1.53v-4.57h1.52v3.05h1.52v-1.53h1.53v-1.52H32v-1.52h-1.52zM25.91 0h4.57v1.52h-4.57Zm0 30.48h4.57V32h-4.57Zm-24.38 0H6.1V32H1.53ZM1.53 0H6.1v1.52H1.53ZM0 25.9h1.53v4.58H0ZM0 1.52h1.53v4.57H0Z\"/>",
  "width": 32,
  "height": 32,
  "viewBox": "0 0 32 32"
}

export default interfaceEssentialVoiceId
